import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import SetupLayout from "./SetupLayout";
import CurationLayout from "./CurationLayout";
import LongListLayout from "./LongListLayout";
import ShortListLayout from "./ShortListLayout";
import AIModeWizard from "../ai-mode/AIModeWizard";
import PartnerDemoWizard from "../partner-demo/PartnerDemoWizard";
import { useSearchConfig } from "../hooks/useSearchConfig";
import { DEFAULT_ROUTES } from "@/constants/routes";

export default function Vision360Layout() {
  const { config } = useSearchConfig();
  const location = useLocation();
  const longListId = new URLSearchParams(location.search).get("l_id");
  const shortListId = new URLSearchParams(location.search).get("s_id");

  const isLongListPath = location.pathname.includes("long-list");
  const isShortListPath = location.pathname.includes("short-list");

  if ((isLongListPath || isShortListPath) && !longListId && !shortListId) {
    return <Navigate to={DEFAULT_ROUTES.VISION_360_BETA_SETUP} replace />;
  }

  if (!config && !isLongListPath && !isShortListPath) {
    return <div>Carregando...</div>;
  }

  return (
    <Routes>
      <Route path="setup" element={<SetupLayout />} />
      <Route path="curation" element={<CurationLayout />} />
      <Route path="long-list" element={<LongListLayout />} />
      <Route path="short-list" element={<ShortListLayout />} />
      <Route path="ai" element={<AIModeWizard />} />
      <Route path="partner-demo" element={<PartnerDemoWizard />} />
      <Route path="*" element={<Navigate to="/vision/setup" replace />} />
    </Routes>
  );
}
